@if (filteredErrors | async; as errors) {
  @if (errors?.length) {
    <app-alert-bar [align]="'top'" [type]="'error'">
      <div class="tw-mb-1.5 tw-font-bold">{{ 'common.validationSummaryTitle' | translate }}</div>
      <ul class="tw-mb-0 tw-pl-4 tw-text-sm">
        @for (error of errors; track error) {
          <li
            (click)="scrollToFormControl(error.name)"
            class="tw-cursor-pointer hover:tw-text-black hover:tw-text-opacity-95 hover:tw-underline"
          >
            {{ error.message }}
          </li>
        }
      </ul>
    </app-alert-bar>
  }
}
